module.exports = "/_next/static/images/4697e013d09db4150b8f40d50c761a72-credit-phase-5.svg";